/* unplugin-vue-components disabled */import script from "./eTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./eTitle.vue?vue&type=script&setup=true&lang=js"

import "./eTitle.vue?vue&type=style&index=0&id=51d6f62e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51d6f62e"]])

export default __exports__